import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import {
  setModalxComponent,
  setModalxComponentProps,
  setModalxOptions,
} from "components/modalx/modalx.slice";

type InvoiceToOpen = {
  id: string;
  customer: string;
  order?: string | null;
};

/** Returns a function that opens the invoice form: to confirm a draft, or to view an issued invoice. */
export default function useOpenInvoiceModal() {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  return (
    invoice: InvoiceToOpen,
    { isDraft, onDone }: { isDraft: boolean; onDone?: () => void }
  ) => {
    dispatch(
      setModalxOptions({
        title: isDraft
          ? t("confirm_invoice", { defaultValue: "Confirm invoice" })
          : t("view_invoice", { defaultValue: "View invoice" }),
      })
    );
    dispatch(setModalxComponent("InvoiceForm"));
    dispatch(
      setModalxComponentProps({
        customerId: invoice.customer,
        orderId: invoice.order || undefined,
        invoiceId: invoice.id,
        onDone,
      })
    );
  };
}
